import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { BoatCrudService } from 'src/app/shared/services/boat-crud.service';
import { Boat } from 'src/app/shared/interfaces/boat';


@Component({
  selector: 'app-boats',
  templateUrl: './boats.component.html',
  styleUrls: ['./boats.component.scss']
})
export class BoatsComponent implements OnInit {

  boats: Boat[];
  boat: Boat;
  selectedBoats: Boat[] = [];

  boatDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private boatService : BoatCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Boats'}
    ];

    this.boats = [];
    this.boat = { } as Boat ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.boatService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.boats = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Boat = jsonItem as Boat;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.boats.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
   // this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.boatService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.boats);
            doc.save('boats.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.boats);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "boats");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedBoats);
      // console.log('SAVEC CSV LOCATIONS ', this.boats);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedBoats, 'boats', exportCols);
   // this.exportService.exportToCsv(this.boats, 'boats', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.boat = {} as Boat;
    this.submitted = false;
    this.boatDialog = true;
  }

  deleteSelectedBoats() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected boats?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.boats = this.boats.filter(val => !this.selectedBoats.includes(val));
            
            this.selectedBoats.forEach( boat => this.boatService.delete(boat.$key));
            this.selectedBoats = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Boatss Deleted', life: 3000});
        }
    });
  }

  editBoat(boat: Boat) {
    this.boat = {...boat};
    this.boatDialog = true;
  }

  deleteBoat(boat: Boat) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + boat.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.boats = this.boats.filter(val => val.$key !== boat.$key);
            this.boat = {} as Boat;
            this.boatService.delete(boat.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Boat Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.boatDialog = false;
    this.submitted = false;
  }

  saveBoat() {
    this.submitted = true;

    if ( this.boat.name.trim() ) {
      if (this.boat.$key) {
          this.boats[this.findIndexById(this.boat.$key)] = this.boat;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Boat Updated', life: 3000});
          this.boatService.update(this.boat);
        } else {
          this.boat.position = this.boats.length;
          this.boatService.add(this.boat);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Boat Created', life: 3000});
      this.boats = [...this.boats];
    }

    this.boatDialog = false;
    this.boat = { } as Boat;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.boats.length; i++) {
        if (this.boats[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeBoat(boat : Boat) {
    this.boatService.update(boat);
  }

  completePosition(boat : Boat) {
    if ( this.newPosition > -1 ) {
        boat.position = this.newPosition;
        boat = this.checkPositionLimits(boat);
        this.reorderElements(boat);
        //this.updateDB(boat);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.boats);
    // const myClonedArray = [];
    // this.boats.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.boats.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.boats.length - 1 - event.dropIndex;
    const boatToMove = this.boats[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.boats[index] = this.boats[index+1];
        this.boats[index].position = index;
        this.boatService.update(this.boats[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.boats[index] = this.boats[index-1];
        this.boats[index].position = index;
        this.boatService.update(this.boats[index]);
      }
    } 
    this.boats[endIndex] = boatToMove;
    this.boats[endIndex].position = endIndex;
    this.boatService.update(this.boats[endIndex]);
  }

  // onFieldEdit(boat: Spray, fieldName: string): void {
  //   //console.log(this.boats);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + boat[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       boat.position = this.newPosition;
  //       boat = this.checkPositionLimits(boat);
  //       this.reorderElements(boat);
  //       //this.updateDB(boat);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(boat);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.boats.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, boat: Boat) {
    // console.log("event" +event);
    if (boat.position != null && boat.position > -1) {
      this.previousPosition = boat.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(boat: Boat) {
    console.log('check ',boat.position + ' ' + this.boats.length);
    if (!boat.position) {
     // console.log('check 1');
      return this.boat;
    }
    if (boat.position < 0) {
      boat.position = 0;
      // console.log('check 2');
      return boat;
    }
    if (boat.position > this.boats.length) {
      boat.position = this.boats.length - 1;
    //  console.log('check 3', boat.position);
      return boat;
    }
   // console.log('check 4');
    return boat;
  }

  async reorderElements(boat: Boat) {
    this.newPosition = this.newPosition  > this.boats.length ? this.boats.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === boat.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const boatToMove = this.boats[startIndex];
   // console.log('Item to move: ', this.boats[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.boats);
        console.log('Item to +1: ', this.boats[index+1]);

        this.boats[index] = this.boats[index+1];
        this.boats[index].position = index;
        // console.log('Move: ', this.boats[index+1]);
        // console.log('Move pos: ', this.boats[index].position);
        //await this.updateDB(this.boats[index]);
        this.boatService.update(this.boats[index]);
     //   console.log('Update DB: ', this.boats[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.boats[index] = this.boats[index-1];
        this.boats[index].position = index;
        this.boatService.update(this.boats[index]);
      }
    } 
    this.boats[endIndex] = boatToMove;
    this.boats[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.boatService.update(this.boats[endIndex]);
    
    // const myClonedArray = [];
    // this.boats.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.boats = myClonedArray;
   // this.getAllRecords();
  }
}
